import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW7400Component } from './kymw7400.component';
import { ConfirmRememberGoodsService } from './api-service/confirm-remember-goods.service';
import { GetRememberGoodsListService } from './api-service/get-remember-goods-list.service';
import { DeleteRememberGoodsListService } from './api-service/delete-remember-goods-list.service';
import { KYMW7401Module } from '../kymw7401/kymw7401.module';
import { KYMW7402Module } from '../kymw7402/kymw7402.module';
import { KYMW7403Module } from '../kymw7403/kymw7403.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    FontAwesomeModule,
    AppCommonsModule,
    KYMW7401Module,
    KYMW7402Module,
    KYMW7403Module,
  ],
  declarations: [
    KYMW7400Component
  ],
  providers: [
    ConfirmRememberGoodsService,
    GetRememberGoodsListService,
    DeleteRememberGoodsListService,
  ]
})
export class KYMW7400Module { }
